import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  search: {
    marginBottom: pxToRem(32),
  },
  item: {
    marginTop: pxToRem(30),
    marginBottom: pxToRem(30),
  },
  resultsMessage: {
    marginBottom: pxToRem(8),
    fontWeight: 600,
  },
  noResultsSentence: {
    marginTop: pxToRem(5),
    fontWeight: 400,
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
});
